import React from 'react'
import { bool, node } from 'prop-types'
import { Flex } from 'theme-ui'

const BaseIcon = ({ isComplete, children, ...rest }) => (
  <Flex
    sx={{
      backgroundColor: isComplete ? 'forest' : 'silver',
      p: '1',
      width: '26px',
      height: '26px',
      borderRadius: '50%',
      transition: '.5s',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    {...rest}
  >
    {children}
  </Flex>
)

BaseIcon.propTypes = {
  isComplete: bool,
  children: node,
}

export default BaseIcon
